module.exports = __webpack_public_path__ + "static/media/download-icon.07c365dd.svg";